/* Seranova: dynamische levertijd (Europe/Amsterdam)
   - Cutoff 16:00. Ma-do voor 16:00 -> volgende dag. Vr voor 16:00 -> zaterdag.
   - Vr na 16:00, za en zo -> dinsdag.
   - Voor de cutoff: "Voor 16:00 besteld <datum> in huis". Erna (of in het weekend): "Nu besteld <datum> in huis".
   - Werkt op de productpagina (.usp-prefix) en in de aankondigingsbalk (.announcement-prefix).
   - Ververst elke minuut, zodat de tekst om 16:00 en 00:00 vanzelf wisselt. */
(function () {
  var CUTOFF_HOUR = 16;

  function amsterdamNow() {
    var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' });
    return new Date(s);
  }

  function compute() {
    var now = amsterdamNow();
    var beforeCutoff = now.getHours() < CUTOFF_HOUR;
    var order = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (!beforeCutoff) order.setDate(order.getDate() + 1);
    var wd = order.getDay(); // 0 = zondag, 6 = zaterdag
    var add = wd === 0 ? 2 : wd === 6 ? 3 : 1;
    var delivery = new Date(order);
    delivery.setDate(order.getDate() + add);
    var weekday = now.getDay() >= 1 && now.getDay() <= 5;
    return {
      beforeCutoff: beforeCutoff && weekday,
      text: delivery.toLocaleDateString('nl-NL', { weekday: 'long' }) + ' ' +
            delivery.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long' })
    };
  }

  function render() {
    var r = compute();
    document.querySelectorAll('.delivery-date').forEach(function (el) {
      el.textContent = r.text;
      var prefix = el.parentElement && el.parentElement.querySelector('.usp-prefix, .announcement-prefix');
      if (prefix) {
        if (!prefix.dataset.original) prefix.dataset.original = prefix.textContent.trim();
        prefix.textContent = r.beforeCutoff ? prefix.dataset.original : 'Nu besteld';
      }
    });
  }

  function patch() {
    var Ctor = customElements.get('delivery-date');
    if (Ctor) Ctor.prototype.loadDate = render;
    render();
  }

  if (customElements.get('delivery-date')) patch();
  else customElements.whenDefined('delivery-date').then(patch);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  setInterval(render, 60 * 1000);
})();